export { default } from './Tooltip'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Tooltip/index.js